"use client";

import React, { useCallback, useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import type { CarouselApi } from "@/components/ui/carousel";
const testimonials = [{
  id: 1,
  author: "Marco D.",
  position: "Gecertificeerd PV-Installateur",
  quote: "Werken met CL Installaties geeft me de zekerheid van goed voorbereide klussen en snelle betalingen. Echt een partner voor de lange termijn."
}, {
  id: 2,
  author: "Sander V.",
  position: "Warmtepomp Specialist",
  quote: "De projecten zijn altijd technisch uitdagend en de materialen staan altijd op tijd klaar op de bouwplaats. Dat scheelt mij veel geregel."
}, {
  id: 3,
  author: "Yassin B.",
  position: "Thuisbatterij Expert",
  quote: "Duidelijke communicatie en een constante stroom aan werk. Sinds ik met CL Installaties samenwerk, hoef ik me geen zorgen meer te maken over acquisitie."
}];
export default function GlosGosci() {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [fadeIn, setFadeIn] = useState(true);
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.15
  });
  useEffect(() => {
    if (!api) return;
    api.on("select", () => {
      setFadeIn(false);
      setTimeout(() => {
        setCurrent(api.selectedScrollSnap());
        setFadeIn(true);
      }, 180);
    });
    setCurrent(api.selectedScrollSnap());
    setFadeIn(true);
  }, [api]);
  const scrollPrev = useCallback(() => {
    api?.scrollPrev();
  }, [api]);
  const scrollNext = useCallback(() => {
    api?.scrollNext();
  }, [api]);
  return <section data-section-id="231238" id="ervaringen-van-collega-vakmensen" ref={ref} className="bg-background text-foreground py-20 px-4 bg-gradient-to-tr from-background to-accent/20">
      <div className={`max-w-4xl mx-auto transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="text-center mb-14">
          <p className="font-default text-sm uppercase tracking-widest mb-3" style={{
          color: "var(--primary)"
        }}>
            Referenties
          </p>
          <h2 className="font-default text-4xl md:text-5xl font-extrabold tracking-tight" style={{
          color: "var(--foreground)"
        }}>
            Ervaringen van collega-vakmensen
          </h2>
          <div className="w-16 h-px mx-auto mt-5" style={{
          background: "var(--primary)"
        }} />
        </div>

        {}
        <Carousel opts={{
        loop: true
      }} setApi={setApi} className="w-full">
          <CarouselContent>
            {testimonials.map((t, i) => <CarouselItem data-index={i} key={t.id}>
                <div className={`flex flex-col items-center text-center px-4 md:px-16 py-12 rounded-lg shadow-lg border border-border/50 transition-opacity duration-300 ${fadeIn ? "opacity-100" : "opacity-0"}`} style={{
              background: "var(--card)"
            }}>
                  {}
                  <span className="font-default text-6xl leading-none mb-4 select-none opacity-20" style={{
                color: "var(--primary)"
              }} aria-hidden="true">
                    &ldquo;
                  </span>

                  {}
                  <blockquote className="font-default text-2xl md:text-3xl font-light italic leading-relaxed mb-8 max-w-2xl" style={{
                color: "var(--card-foreground)"
              }}>
                    {t.quote}
                  </blockquote>

                  {}
                  <div className="flex items-center gap-1 mb-6">
                    {[1, 2, 3, 4, 5].map((star, si) => <Star key={si} className="size-4 fill-current" style={{
                  color: "var(--primary)"
                }} />)}
                  </div>

                  {}
                  <div>
                    <p className="font-default text-lg font-bold tracking-wide" style={{
                  color: "var(--card-foreground)"
                }}>
                      {t.author}
                    </p>
                    <p className="font-sans text-sm tracking-wider uppercase mt-1" style={{
                  color: "var(--muted-foreground)"
                }}>
                      {t.position}
                    </p>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="flex items-center justify-center gap-6 mt-8">
            <Button variant="ghost" size="icon" onClick={scrollPrev} className="rounded-full border transition-all duration-300 hover:bg-primary/10" style={{
            borderColor: "var(--primary)",
            color: "var(--primary)"
          }} aria-label="Vorige">
              <ChevronLeft className="size-5" />
            </Button>

            {}
            <div className="flex items-center gap-2">
              {testimonials.map((_, i) => <Button key={i} variant="ghost" onClick={() => api?.scrollTo(i)} className="rounded-full transition-all duration-300 p-0" style={{
              width: current === i ? "24px" : "8px",
              height: "8px",
              background: current === i ? "var(--primary)" : "var(--muted-foreground)",
              opacity: current === i ? 1 : 0.4,
              border: "none"
            }} aria-label={`Ga naar ervaring ${i + 1}`} />)}
            </div>

            <Button variant="ghost" size="icon" onClick={scrollNext} className="rounded-full border transition-all duration-300 hover:bg-primary/10" style={{
            borderColor: "var(--primary)",
            color: "var(--primary)"
          }} aria-label="Volgende">
              <ChevronRight className="size-5" />
            </Button>
          </div>
        </Carousel>
      </div>
    </section>;
}